import { db } from "../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetAgentProperties = async (agentID) => {
  try {
    const propertyCollection = await collection(db, "properties");

    const q = query(
      propertyCollection,
      where("bid", "==", getLocalStorageItem("bid")),
      where("agent", "==", agentID)
    );
    const AgentsSnapshot = await getDocs(q);

    let agentProperties = [];

    AgentsSnapshot.forEach((doc) => {
      agentProperties.push({ ...doc.data(), id: doc.id });
    });
    return agentProperties;
  } catch (error) {
    console.log(error);
  }
};

export default GetAgentProperties;
